<template>
  <div class="electron:overflow-hidden flex flex-col electron:flex-grow gap-2">
    <ProjectNavigation :on-click-reload-page="onCLickReloadNavigation" ref="project-navigation"></ProjectNavigation>

    <!--
    <div v-if="isPageOpen" class="flex mb-2">
      <div class="p-2 cursor-pointer bg-trader-blue text-white" data-ui="page-view">Seitenansicht</div>
      <div @click="routerPush('list')" class="p-2 cursor-pointer bg-trader-gray" data-ui="list-view">Listenansicht</div>
      <div @click="routerPush('sort')" class="p-2 cursor-pointer bg-trader-gray" data-ui="change-position">Position ändern</div>
    </div>
    -->

    <!-- <TRTheme></TRTheme> -->

    <div class="electron:px-2 flex justify-between max-w-[643px]">
      <PageModiTab v-if="isPageOpen" :project-id="this.projectId" :magazine-id="this.magazineId"
                   :page-position="this.pagePosition" :market-id="this.marketId">

      </PageModiTab>
      <drop-down  :bind-right="true" v-if="isPageOpen && userData?.isAdmin">
        <template v-slot:title>
          <div class="p-2 px-3 cursor-pointer h-full bg-trader-gray text-trader-text hover:bg-trader-blue">
            <i class="fa-solid fa-bars"></i>
          </div>
        </template>
        <template v-slot:menu>
          <div class="flex flex-col gap-2 p-2">
            <!-- Standard-Artikel -->
            <button @click="deleteArticle('page' , false)"
                    class="px-3 py-1 bg-trader-gray text-trader-text hover:bg-trader-blue">
              Alle Artikel auf der Seite
              <span class="text-trader-red font-semibold">Löschen</span>
            </button>
            <button @click="deleteArticle('magazine' , false)"
                    class="px-3 py-1 bg-trader-gray text-trader-text hover:bg-trader-blue">
              Alle Artikel vom Magazin
              <span class="text-trader-red font-semibold">Löschen</span>
            </button>
            <!-- Virtuelle Artikel -->
            <button @click="deleteArticle('page' , true)"
                    class="px-3 py-1 bg-trader-gray text-trader-text hover:bg-trader-blue">
              Alle
              <span class="text-trader-green font-semibold">Virtuellen</span> Artikel auf der Seite
              <span class="text-trader-red font-semibold">Löschen</span>
            </button>
            <button @click="deleteArticle('magazine' , true)"
                    class="px-3 py-1 bg-trader-gray text-trader-text hover:bg-trader-blue">
              Alle
              <span class="text-trader-green font-semibold">Virtuellen</span> Artikel vom Magazin
              <span class="text-trader-red font-semibold">Löschen</span>
            </button>
          </div>
        </template>

      </drop-down>
    </div>

    <div v-if="isPageOpen && page && userData != null"
         class="flex flex-grow gap-2 electron:px-2 electron:overflow-hidden electron:pb-2"
         :key="page.pageId">
      <div class="flex-grow electron:flex electron:flex-col ">
        <ProductHeader class="electron:flex-shrink-0" :formular-id="formId" :product="productHeader"
                       :header="true"></ProductHeader>

        <div class=" electron:overflow-auto">
          <accordion ref="accordion" :active="productIndex" :on-change="onAccordionChange" class="">
            <accordion-item v-for="(product, index) in products" v-bind:key="product" class=""
                            :highlight="highlightedMagazines[page.magazineId]?.pages[page.pagePosition]?.products[product.productId]?.highlight == true">
              <!-- accordion header -->
              <template v-slot:accordionTrigger="{visible}">
                <ul class="w-full  dark:rounded overflow-hidden">
                  <ProductHeader :formular-id="formId" :product="product" :visible="visible"></ProductHeader>
                </ul>
              </template>

              <!-- accordion content -->
              <template v-slot:accordionContent>
                <ProductFormular :page="page" :product="product" :reload-page="getPage"
                                 :on-click-reload-page="getPage"
                                 :active="parseInt(activeProductIndex) === parseInt(index)"
                                 :product-for-fields="productFormFields"
                                 :magazine-name="null" :header="true" :form-names="formNames"
                                 :form-id="formId" :show-preview-templates="showPreviewTemplates"></ProductFormular>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>

      <div class="w-345 flex flex-col gap-1 flex-shrink-0 electron:overflow-auto ">
        <tabs v-if="!isPageLocked" v-model="activeTab" :key="isNonFood">
          <tab :title="$t('tab.title.picturesearch')" tab-class="max-w-[85px]">
            <ImageTab/>
          </tab>
          <tab v-if="showPreviewTemplates" :title="$t('tab.title.articletemplate')" tab-class="max-w-[85px]">
            <TemplateTap/>
          </tab>
          <tab :title="$t('tab.title.clipboard')" tab-class="max-w-[85px]">
            <ClipboardTap :product="product" :page="this.page" :active-product-index="activeProductIndex"
                          :on-click-reload-page="getPage"/>
          </tab>
          <tab v-if="isNonFood" :title="$t('tab.title.pagetemplates')" tab-class="max-w-[85px]">
            <PageTemplateTab></PageTemplateTab>
          </tab>
        </tabs>

        <div class="flex flex-col gap-2" v-if="isPageOpen && !isPageLocked">
          <button
              class="bg-trader-green text-trader-dark-green w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
              @click="savePage" data-ui="button-page-view-save-page-changes">
            Seite speichern
          </button>
        </div>

        <!-- market list -->
        <div v-if="page?.marketId > 0 " class="w-full bg-primary p-2">
          <p class="">Teil des Marktes:</p>
          <div class="grid grid-cols-8 text-center ">

            <div v-if="marketList?.length > 0" v-for="market in marketList.filter(item => item.isActive)"
                 v-bind:title="market.description"
                 @click="openMarket(market.marketId)"
                 :data-ui="market.name"
                 class="font-bold flex flex-col   cursor-pointer hover:bg-trader-blue hover:text-white  "
                 :class="{'text-trader-market-red': market.isFull, 'text-trader-market-green': !market.isFull, 'bg-trader-blue text-white': market.marketId == marketId, 'bg-trader-red': highlightedMagazines[page.magazineId]?.pages[page.pagePosition]?.markets[market.marketId]?.highlight == true}"
                 v-bind:key="market">

              <span :class="{'text-trader-market-blue ': activeProductMarkets.includes(market.marketId)}">
                 {{ market.sapMarketName }}
              </span>
              <span class="font-normal text-[8pt] leading-[4pt] pb-[6px] text-trader-text">

                    {{ market.name }}
              </span>

            </div>
          </div>

        </div>

        <div v-if="page?.marketId > 0" class="w-full bg-primary p-1 px-2 cursor-pointer"
             @click="showLegend = !showLegend">
          <!-- Flex-Container für Text + Icon -->
          <p class="mb-2 flex justify-between items-center">
            <span>Legende:</span>
            <!-- Icon wechselt je nach showLegend -->
            <i class="fa-solid" :class="showLegend ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </p>

          <!-- Nur im offenen Zustand die Legende -->
          <div v-if="showLegend">
            <table id="legend_description" class="team_tb_legend" style="font-size:11px; font-weight:bolder;">
              <tbody>
              <tr>
                <td>
                  <span class="text-trader-market-green whitespace-nowrap"> grüne Schrift</span>
                  – Platz auf der Seite für den Markt verfügbar/unbelegt
                </td>
              </tr>
              <tr>
                <td>
              <span class="text-trader-market-blue whitespace-nowrap">
                blaue Schrift
              </span>
                  – Artikel bereits auf der Seite für den Markt vorhanden
                </td>
              </tr>
              <tr>
                <td>
              <span class="text-trader-market-red whitespace-nowrap">
                rote Schrift
              </span>
                  – Kein Platz mehr für einen weiteren Artikel
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div v-if="isPageOpen" class="w-full bg-trader-gray  flex flex-col">
          <p class="bg-trader-darker-gray text-center text-white py-1">Seiteneigenschaften</p>
          <div class="flex flex-col gap-2 p-2">

            <div v-if="page.name === '' " class=" overflow-auto w-full">
              Seitenname: <span class="text-trader-darkest-gray w-full">keine Themenseite</span>
            </div>
            <span v-else class="overflow-auto w-full">
            Seitenname: {{ page.name }}
          </span>

            <!-- NonFood Braunschweig Checkbox -->

            <div v-if="isNonFood" class="w-full  flex items-center gap-2"
                 :class="{'bg-trader-red': getAttributeObject('braunschweig', 'boolean').highlight}"
                 title="Für Braunschweig geeignet">
              <input type="checkbox" id="nonFoodCheckbox" :checked="getAttributeValue('braunschweig', 'boolean')"
                     @change="setAttributeValue('braunschweig', 'boolean', $event.target.checked)">
              <label for="nonFoodCheckbox">Für Braunschweig geeignet</label>
            </div>

            <div v-if="pageAttributeHasChanged">
              <button
                  class="w-full bg-red-400 text-white h-8 p-2 cursor-pointer hover:bg-trader-dark-red text-center whitespace-nowrap"
                  data-ui="button-page-view-reset-page-changes"
                  @click="resetAttributeChanges">Änderungen zurücksetzen
              </button>
            </div>
          </div>
        </div>

        <div v-if="!showPreviewTemplates && isPageOpen" class="mt-2">
          <button @click="openInMediaDesignerAgent" class="bg-trader-gray w-full p-2 mb-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
                  data-ui="button-open-mediadesigneragent">
            In MediaDesign Agent öffnen
          </button>
        </div>

        <div :style="pagePreviewStyleObject">
          <object v-if="showPreviewTemplates && isPageOpen && page?.pageId > 0 " :key="page.pageId"
                  class="w-full h-full" type="image/svg+xml" rel="pagePreview"
                  style="display:inline-block;position:relative; overflow:hidden;" :style="pagePreviewStyleObject"
                  :data="'/api/v3/preview/page/' + page.pageId + '?callback=pagepreview&random='+random+'&show_numbers='+showNumbers+'&show_notes='+showNotes+'&clickable=true&quality=2'">
            <param name="type" value="image/svg+xml">
          </object>
        </div>



        <div v-if="showPreviewTemplates && isPageOpen && !isPageLocked">
          <button @click="openInEasyControl" class="bg-trader-gray w-full p-2 mb-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
                  data-ui="button-open-easycontrol">
            In EasyControl öffnen
          </button>
          <button class="bg-trader-gray w-full p-2 hover:bg-trader-hover-background hover:text-trader-hover-text"
                  @click="openPageRaster" data-ui="button-open-grid-settings-trader">Raster anpassen
          </button>
        </div>

        <!-- more buttons -->
        <div v-if="showPreviewTemplates && isPageOpen" class="flex gap-1">
          <div @click="openPrintDialog" title="Drucken" data-ui="print-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i class="fa-solid fa-print leading-8"></i>
          </div>

          <div @click="openPagePreview" title="Vorschau vergrößern" data-ui="preview-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i class="fa-solid fa-magnifying-glass-plus leading-8"></i> <!-- Vorschau zeigen icon--->
          </div>

          <div @click="toggleNotes" title="Notizen zeigen/verstecken" data-ui="toggle-notes"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i v-if="showNotes" class="fa-solid fa-toggle-on leading-8"></i>
            <i v-else class="fa-solid fa-toggle-off leading-8"></i> <!-- Notizen zeigen icon--->
          </div>

          <div @click="toggleNumbers" data-ui="toggle-numbers"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer"
               title="Platzhalter Nummerierung zeigen/verstecken">
            <i class="fa-solid fa-list-ol leading-8"></i> <!-- Nummern Vorschau zeigen an aus icon --->
          </div>

          <div @click="openPageHistory" title="Historie zeigen" data-ui="history-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i class="fa-regular fa-calendar-days leading-8"></i> <!-- History zeigen icon--->
          </div>

          <div v-if="userData.isAdmin" @click="openTimeTravel" data-ui="time-travel-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer"
               title="TimeTravel">
            <i class="fa-solid fa-clock-rotate-left leading-8"></i>
          </div>

          <div v-if="userData.isAdmin" @click="openAbracadabra" data-ui="time-travel-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer"
               title="Abrakadabra">
            <i class="fa-solid fa-wand-magic-sparkles leading-8"></i>
          </div>



          <div v-if="userData.isAdmin" @click="openInDesignExportDialog" title="InDesign Export"
               data-ui="indesign-export-button"
               class="w-full h-8 bg-primary text-center hover:bg-trader-blue hover:text-white cursor-pointer">
            <i class="fa-solid fa-download leading-8"></i>
          </div>

          <div v-if="userData.isAdmin" title="Seitentemplate in InDesign öffnen" data-ui="open-indesign-button"
               @click="() => { openPageTemplateInIndesign({pageTemplateId: page.pageTemplateId}); }"
               class="w-full h-8 text-center hover:bg-trader-blue hover:text-white cursor-pointer text-sm bg-indesign-dark text-indesign-light">
            <div class="leading-8 font-bold">Id</div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import ProjectNavigation from "@/components/ProjectNavigation/ProjectNavigation.vue";
import Tab from "@/components/Tabs/Tab.vue";
import Tabs from "@/components/Tabs/Tabs.vue";
import Accordion from "@/components/Accordion/Accordion";
import AccordionItem from "@/components/Accordion/AccordionItem";
import MainMenu from "../components/MainMenu/MainMenu";
import ProductFormularImage from "../components/ProductFormularPicture/ProductFormularImage";
import Draggable from "vue3-draggable";
import ShowPreview from "@/components/Preview/ShowPreview.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "../apolloClient";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import ImageTab from "@/components/Tabs/ImageTab.vue";
import {eventBus} from "@/application/EventBus";
import History from "../views/History.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import db from "@/application/db";
import ClipboardTap from "@/components/Tabs/ClipboardTap.vue";
import TemplateTap from "@/components/Tabs/TemplateTap.vue";
import router from "@/router";
import SavePageMarketSelection from "@/components/Dialogs/SavePageMarketSelection.vue";
import {highlightedMagazines, reloadHighlights} from "../application/Highlighter.js";
import {mapActions, mapGetters, mapState} from "vuex";
import SignalBus from "@/application/SignalBus";
import PageTemplateTab from "@/components/Tabs/PageTemplateTab.vue";
import InDesignExportDialog from "@/components/Dialogs/InDesignExportDialog.vue";
import DialogPrint from "@/components/Dialogs/DialogPrint.vue";
import DTimeTravel from "@/components/Dialogs/DTimeTravel.vue";
import PageModiTab from "@/components/PageModiTab/PageModiTab.vue";
import storage from "@/application/storage";
import TRTheme from "@/components/Base/v2/TRTheme.vue";
import {mutation, query} from "@/graphql";
import DropDown from "@/components/MainMenu/DropDown.vue";
import {dialog} from "@/dialog";
import DAbracadabra from "@/components/Dialogs/DAbracadabra.vue";

export default {
  computed: {
    ...mapState({
      pageId: state => state.pageId,
      productId: state => state.productId,
    }),
    ...mapState('page', ['page']),
    ...mapGetters('page', ['pageSide']),
    ...mapGetters('page', ['isNonFood']),
    ...mapState('user', ['userData']),
    ...mapState('settings', ['showNumbers', 'showNotes', 'showPreviewTemplates']),
    ...mapGetters('page', ['isPageLocked']),
    isPageOpen() {
      return this.products.length > 0;
    },
    pageAttributeHasChanged() {
      return Object.values(this.pageAttributes).some(attr => attr.highlight);
    }
  },
  data() {
    return {
      random: Math.random(),
      pagePreviewStyleObject: {
        height: '1000px',
      },
      highlightedMagazines: highlightedMagazines,
      productHeader: {
        productCustomFields: [
          {field: "position", value: "#"},
          {field: "article_number", value: "Art.Nr."},
          {field: "tg_name", value: "Produkttext"},
          {field: "quantity", value: "Menge"},
          {field: "quantity_2nd_field", value: "Inhalt"},
          {field: "unit", value: "Einheit"},
          {field: "package_type", value: "Verp"},
          {field: "price_per_unit", value: "Preis"},
          {field: "price", value: "Netto"},
          {field: "vat", value: "MwSt"}
        ]
      },

      activeView: "list",
      activeTab: 0,
      products: [],
      productFormFields: [],
      projectId: 0,
      magazineId: 0,
      pagePosition: 0,
      marketId: 0,
      productIndex: null,
      marketList: [],
      showLegend: true,
      activeProductMarkets: [],
      formNames: [],
      formId: 0,
      headerData: [],
      activeProductIndex: 0,
      pageAttributes: {},
      searchArticleNumber: '',
      articleFormMarkets: [],
      placeholderPosition: [],
      pageListData: [],
      selectedMarkets: [],
      marketData: [],
      showArticleOnMagazine: false,
      selectedMarketId: null,
      selectedArticleNumber: null,
      selectedStates: {},
      setArticleNumberInput: false,
    }
  },
  components: {
    DropDown,
    TRTheme,
    PageModiTab,
    ShowPreview,
    TemplateTap,
    ClipboardTap,
    ImageTab,
    ProductFormular,
    ProjectNavigation,
    Tab,
    Tabs,
    Accordion,
    AccordionItem,
    MainMenu,
    ProductFormularImage,
    Draggable,
    ProductHeader,
    History,
    PageGrid,
    SavePageMarketSelection,
    PageTemplateTab,
  },
  methods: {
    ...mapActions('page', ['fetchPage']),
    ...mapActions('indesign', ['openPageTemplateInIndesign']),
    ...mapActions('settings', ['toggleNumbers', 'toggleNotes']),


    openPrintDialog() {
      eventBus.openModal(DialogPrint, {
        magazineId: this.page.magazineId,
        maxPageCount: this.page.magazinePageCount,
        marketList: this.marketList,
        activePage: this.page.pagePosition,
      });
    },
    toggleNetPrice(marketId, articleNumber) {
      const key = marketId + '_' + articleNumber;
      this.selectedStates[key] = !this.selectedStates[key];
    },
    isSelected(marketId, articleNumber) {
      const key = marketId + '_' + articleNumber;
      return this.selectedStates[key];
    },

    getMarketIds(marketId, index) {
      const foundIndex = this.selectedMarkets.findIndex(item => item.marketId === marketId && item.index === index);
      if (foundIndex !== -1) {
        this.selectedMarkets.splice(foundIndex, 1);
      } else {
        this.selectedMarkets.push({marketId: marketId, index: index});
      }
      this.marketData = [...this.selectedMarkets];
    },
    isMarketSelected(marketId, index) {
      return this.articleFormMarkets.some(articleMarket =>
          articleMarket.marketId === marketId && this.productPosition == index
      );
    },
    deleteArticle(type, isVirtual) {
      const artikelText = isVirtual ? 'Virtuelle Artikel' : 'Artikel';
      // HIER: 'page' statt 'seite'
      const scopeText = type === 'page'
          ? 'auf dieser Seite'
          : 'vom Magazin';
      const title = `${artikelText} löschen`;
      const message = `Möchten Sie alle ${artikelText.toLowerCase()} ${scopeText} wirklich löschen?`;

      dialog.deleteDialog({
        title,
        message,
        onAccept: async () => {
          const [data, err] = await mutation.deleteArticle(type, isVirtual, this.page?.magazineId, this.page?.pageId);
          if (err) {
            console.error(err);
            return;
          }
          await this.getPage()
        }
      });
    },
    getAttributeObject(key) {
      if (this.pageAttributes[key] === undefined) {
        this.pageAttributes[key] = {value: '', highlight: false};
      }
      return this.pageAttributes[key];
    },
    getHighlight(key) {
      return this.getAttributeObject(key);
    },
    getAttributeValue(key, type) {
      const attrObject = this.getAttributeObject(key)
      if (type === 'boolean') {
        return attrObject.value === '1';
      }
      return attrObject.value;
    },
    async setAttributeValue(key, type, value) {
      const attrObject = this.getAttributeObject(key)
      attrObject.value = type === 'boolean' ? value ? '1' : '0' : value;
      attrObject.highlight = true;

      await this.saveAttributeState('page-attribute', key, attrObject.value);
      reloadHighlights();
    },
    async saveAttributeState(type, key, value) {
      await db.transaction('rw', db.customfields, async () => {
        const existingField = await db.customfields
            .where('magazineId').equals(this.page.magazineId)
            .and(item => item.pagePosition === this.page.pagePosition && item.key === key)
            .first();
        if (!existingField) {
          await db.customfields.add({
            projectId: this.page.projectId,
            magazineId: this.page.magazineId,
            pagePosition: this.page.pagePosition,
            type: type,
            key: key,
            value: value,
          });
        } else {
          await db.customfields.update(existingField.id, {value});
        }
      }).catch(err => {
        console.error(err.stack || err);
      });
    },
    resetAttributeChanges() {
      db.customfields.where('magazineId').equals(this.page.magazineId)
          .and(row => row.pagePosition === this.page.pagePosition)
          .and(row => row.type === 'page-attribute')
          .delete();

      for (const key in this.pageAttributes) {
        this.pageAttributes[key].highlight = false;
        this.pageAttributes[key].value = this.pageAttributesDefault[key]?.value || '';
      }
      reloadHighlights();
    },
    openPageRaster() {
      eventBus.openModal(PageGrid, {
        pageId: this.page.pageId,
      }, {
        halfSize: true
      });
    },
    async openInMediaDesignerAgent() {
      try {
        // Prepare request data
        const requestData = {
          project_id: this.projectId.toString(),
          magazine_id: this.magazineId,
          page_id: this.page.pageId,
          page: this.pagePosition.toString(),
          pages: '1,2,3', // TODO: Get actual pages list if needed
          market: this.marketId > 0 ? this.marketId.toString() : '',
        };



          // Redirect to EasyControl with session token
          window.open('http://localhost:5173/editor/'+this.page.pageId, '_blank');

      } catch (error) {
        console.error('Error opening EasyControl:', error);
        alert('Fehler beim Öffnen von EasyControl. Bitte versuchen Sie es erneut.');
      }

    },
    async openInEasyControl() {
      try {
        // Prepare request data
        const requestData = {
          project_id: this.projectId.toString(),
          magazine_id: this.magazineId,
          page_id: this.page.pageId,
          page: this.pagePosition.toString(),
          pages: '1,2,3', // TODO: Get actual pages list if needed
          market: this.marketId > 0 ? this.marketId.toString() : '',
        };

        // Call backend endpoint to get EasyControl session token
        const response = await fetch('/api/v3/easycontrol/open-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();

        if (data.success && data.token && data.easycontrol_url) {
          // Redirect to EasyControl with session token
          const easycontrolUrl = `${data.easycontrol_url}${data.token}`;
          window.open(easycontrolUrl, '_blank');
        } else {
          console.error('Failed to get EasyControl session token:', data);
          alert('Fehler beim Öffnen von EasyControl. Bitte versuchen Sie es erneut.');
        }
      } catch (error) {
        console.error('Error opening EasyControl:', error);
        alert('Fehler beim Öffnen von EasyControl. Bitte versuchen Sie es erneut.');
      }
    },
    onCLickReloadNavigation() {

    },
    openPageHistory() {
      eventBus.openModal(History);
      eventBus.setData({
        pageId: this.page.pageId,
        productId: this.productId
      });
    },
    openPagePreview() {
      eventBus.openModal(ShowPreview, {
        pageId: this.page.pageId,
        magazineId: this.page.magazineId || this.magazineId,
        marketId: this.page.marketId,
        quality: 3,
      }, {fullSize: true});
    },
    openTimeTravel() {
      eventBus.openModal(DTimeTravel, {
        pageId: this.page.pageId,
        title: "TimeTravel",
        reloadPage: this.getPage
      });
    },
    openAbracadabra() {
      eventBus.openModal(DAbracadabra, {
        pageId: this.page.pageId,
        title: "Abrakadabra",
        reloadPage: this.getPage
      }, {
        halfSize: true
      });
    },
    openInDesignExportDialog() {
      eventBus.openModal(InDesignExportDialog);
      eventBus.setData({
        pageId: this.page.pageId,
        marketList: this.marketList,
      });
    },
    reloadObject() {
      const objectElement = document.querySelector('object[rel="pagePreview"]');
      const objectData = objectElement.data;
      objectElement.data = '';
      objectElement.data = objectData;
    },
    async onAccordionChange(index) {

      let product = this.products[index];
      await storage.set('articleNumber', product?.articleNumber || null); //product?.articleNumber || null


      this.activeProductIndex = index;
      this.activeProductMarkets = []
      router.push('/project/' + this.projectId + "/" + this.magazineId + "/" + this.pagePosition + "/" + this.marketId + "/" + index);
      if (product?.productId == 0) {
        SignalBus.emit('set_focus');
      } else {
        this.setArticleNumberInput = false
      }
      this.$store.commit('setProductTemplateId', product?.productTemplateId || null);
      this.$store.commit('setProductId', product?.productId || null);
      this.$store.commit('setPlaceholderSize', {
        width: product?.placeholderWidth || 0,
        height: product?.placeholderHeight || 0
      });
      product?.marketIds.forEach((item) => {
        this.activeProductMarkets.push(item);
      });


    },
    async getProductFormHeaders(formId) {
      try {
        const response = await apolloClient.query({
          query: gql`
            query  getProductFormHeaders {
              getProductFormHeaders {
                idProductFormHeader
                idProductForm
                label
                field
                size
              }
            }
          `,
        });
        try {
          this.headerData = response.data.getProductFormHeaders
        } catch (error) {
          console.error(error);
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der getProductFormHeader:", error);
      }
    },
    openMarket(marketId) {
      router.push('/project/' + this.projectId + "/" + this.magazineId + "/" + this.pagePosition + "/" + marketId);
    },
    async savePageForMarkets(page) {
      const oldAccordionIndex = this.activeProductIndex;
      const query = gql`
            mutation SavePage($page: PageInput!) {
                savePage(page: $page) {
                    success
                }
            }
        `;
      const {data} = await apolloClient.mutate({mutation: query, variables: {page}});
      if (data?.savePage?.success) {
        page.products.forEach(product => {
          db.customfields
              .where('magazineId').equals(this.page.magazineId)
              .and(field => field.pagePosition === this.page.pagePosition)
              .and(field => field.productId === product.productId)
              .delete();
        });
        db.customfields
            .where('magazineId').equals(this.page.magazineId)
            .and(field => field.pagePosition === this.page.pagePosition)
            .and(field => (field.productId === undefined || field.productId === null))
            .delete();
        reloadHighlights();
        this.getPage(() => {
          this.$refs.accordion.open(oldAccordionIndex);
          this.onAccordionChange(oldAccordionIndex);
        });
        this.random = Math.random();
      } else {
        console.error("Unerwartete Daten von Apollo Client erhalten:", data);
      }
    },
    async savePage() {
      const customFields = await db.customfields
          .where('magazineId').equals(this.page.magazineId)
          .and(field => field.pagePosition === this.page.pagePosition).toArray();
      let products = {};
      let attributes = [];
      customFields.forEach(item => {
        if (item.productId === undefined || item.productId === null) {
          attributes.push({
            key: item.key,
            value: item.value
          });
        } else {
          const productId = parseInt(item.productId);
          const markets = JSON.parse(item.marketIds);
          if (markets.indexOf(this.page.marketId) < 0) {
            return;
          }
          if (typeof products[productId] === 'undefined') {
            products[productId] = {
              productId: productId,
              articleNumber: item.articleNumber,
              marketIds: JSON.parse(item.marketIds),
              productCustomFields: [],
              pictures: [],
              logos: [],
              productTemplateId: 0,
            };
          }
          if (item.type == 'field') {
            products[productId].productCustomFields.push({
              field: item.key,
              value: item.value
            });
          }
          if (item.type == 'template') {
            products[productId].productTemplateId = item.value || 0;
          }
          if (item.type == 'picture') {
            let pictures = JSON.parse(item.value);
            pictures.forEach((picture) => {
              products[productId].pictures.push({
                productPictureId: picture.productPictureId || 0,
                pictureId: picture.pictureId || 0,
                //previewSmall: picture.previewSmall,
                //previewMedium: picture.previewMedium,
                //previewLarge: picture.previewLarge,
                isActive: picture.isActive,
                position: picture.position,
                markedForDeletion: picture.markedForDeletion,
                isDefault: picture.isDefault,
                isRemoved: picture.isRemoved
              });
            });
          }
          if (item.type == 'logo') {
            let logos = JSON.parse(item.value);
            logos.forEach((logo) => {
              products[productId].logos.push({
                productLogoId: logo.productLogoId || 0,
                pictureId: logo.pictureId || 0,
                //previewSmall: logo.previewSmall,
                //previewMedium: logo.previewMedium,
                //previewLarge: logo.previewLarge,
                isActive: logo.isActive,
                position: logo.position,
                markedForDeletion: logo.markedForDeletion,
                isRemoved: logo.isRemoved
              });
            });
          }
        }
      });
      let page = {
        magazineId: this.page.magazineId,
        pagePosition: this.page.pagePosition,
        products: [],
        attributes: attributes,
      };
      for (let productId in products) {
        page.products.push(products[productId]);
      }
      if (this.page.marketId == 0) {
        await this.savePageForMarkets(page);
        return;
      }
      eventBus.openModal(SavePageMarketSelection);
      eventBus.setData({
        page: page,
        selectedMarketId: this.page.marketId,
        marketList: this.marketList,
        productFormFields: this.productFormFields,
        onSave: this.savePageForMarkets
      });
    },
    changeUrl() {
      const index = this.activeProductIndex;
      this.getPage();
      this.random = Math.random();
    },
    async getFormNames() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getFormularNames {
              getFormularNames {
                idForm
                name
                magazineType
              }
            }
          `
        });
        this.formNames = response.data.getFormularNames;
        let f = null;
        this.formNames.forEach((item) => {
          f = f === null && item.magazineType === 0 ? item.idForm : f;
          f = item.magazineType === this.page?.magazineTypeId ? item.idForm : f;
        });
        this.formId = f;
      } catch (error) {
        console.error("Fehler beim Abrufen der getFormField:", error);
      }
    },
    getPage(callback) {

      if (this.magazineId === "" || this.magazineId === undefined || this.pagePosition === "" || this.pagePosition === undefined || this.marketId === "" || this.marketId === undefined) {
        this.$store.commit('setPageId', null);
        this.products = [];
        return;
      }
      this.fetchPage({
        magazineId: this.magazineId,
        pagePosition: this.pagePosition,
        marketId: this.marketId,
      }).then(() => {

        if (this.page === null) {
          this.products = [];
          return;
        }

        this.$refs?.accordion?.reset();
        this.products = this.fixPosition(this.page.products);
        this.pageAttributes = {};
        this.page.attributes.forEach(item => {
          this.pageAttributes[item.key] = {value: item.value, highlight: false};
        });
        this.pageAttributesDefault = JSON.parse(JSON.stringify(this.pageAttributes));
        this.loadUserChanges();
        this.$store.commit('setPageId', this.page?.pageId || null);
        this.getFormNames();
        this.random = Math.random();
        this.$refs.accordion?.open(this.productIndex);
        this.onAccordionChange(this.productIndex);
        if (callback) {
          callback();
        }
        this.getMarkets();
      });
    },
    async loadUserChanges() {
      const results = await db.customfields.where('magazineId').equals(this.page.magazineId).and(field => field.pagePosition === this.page.pagePosition).toArray();
      results.forEach(item => {
        if (item.type == 'page-attribute') {
          this.pageAttributes[item.key].value = item.value;
          this.pageAttributes[item.key].highlight = true;
        }
      });
    },
    async getArticleFromMarkets() {
      this.showArticleOnMagazine = true;
      const query = gql`
        query getArticleFromMarkets($articleNumber: String!, $pageId: Int!, $magazineId: Int!, $pagePosition: String!, $virtualId: Int! ) {
          getArticleFromMarkets(articleNumber: $articleNumber, pageId: $pageId, magazineId: $magazineId, pagePosition: $pagePosition, virtualId: $virtualId) {
             marketId
             position
          }
         }
      `;
      try {
        let placeholderId = this.page.products[this.activeProductIndex].placeholderId;
        const {data} = await apolloClient.query({
          query,
          variables: {
            articleNumber: this.searchArticleNumber,
            pageId: this.page.pageId,
            magazineId: this.page.magazineId,
            pagePosition: this.page.pagePosition,
            virtualId: placeholderId
          }
        });
        this.articleFormMarkets = [];
        this.articleFormMarkets = data.getArticleFromMarkets
        this.articleFormMarkets.forEach((item) => {
          this.selectedMarkets.push({marketId: item.marketId})
        });
        this.page.products.forEach(page => {
          if (this.searchArticleNumber == page.articleNumber) {
            this.productPosition = page.placeholderPosition
          }
        })
      } catch (error) {
        console.error(error);
      }
    },
    async getMarkets() {
      const [data, err] = await query.getMarketsStatus(this.page.magazineId, this.page.pagePosition);
      this.marketList = data;
      if (err) {
        console.error(err);
      }
    },
    numberToAlphabetChar(zahl) {
      let buchstaben = "";
      while (zahl > 0) {
        let modulo = (zahl - 1) % 26;
        buchstaben = String.fromCharCode(97 + modulo) + buchstaben;
        zahl = Math.floor((zahl - modulo) / 26);
      }
      return buchstaben;
    },
    fixPosition(product) {
      let ppc = {};
      product.forEach((item, index) => {
        ppc[item.placeholderPosition] = (typeof ppc[item.placeholderPosition] === 'undefined') ? 1 : ppc[item.placeholderPosition] + 1;
      });
      product.forEach((item, index) => {
        item.positionTitle = ppc[item.placeholderPosition] > 1 ? item.placeholderPosition + this.numberToAlphabetChar(item.productPosition) : item.placeholderPosition;
      });
      return product;
    },
  },
  mounted() {
    this.getProductFormHeaders()
    window.crossApi.onClickPlaceholder = (placeholderId) => {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].placeholderId === placeholderId) {
          this.$refs.accordion.open(i);
          this.onAccordionChange(i);
          break;
        }
      }
    }
    window.crossApi.callbacks['pagepreview'] = (w, h) => {
      this.pagePreviewStyleObject = {
        height: h + 'px',
      };
    };
    SignalBus.connect(this, 'article-created', this.getPage);
    SignalBus.connect(this, "reload-save-grid", this.getPage);
    SignalBus.connect(this, "formular-reload-clipboard", this.getPage);
    SignalBus.connect(this, "reload-project-page", this.getPage)
    SignalBus.connect(this, "", this.getPage);
  },
  created() {
    this.getProductFormHeaders()
    this.getFormNames();
    if (this.$isParamDefined('projectId')) {
      this.projectId = this.$route.params.projectId;
    }
    if (this.$isParamDefined('magazineId')) {
      this.magazineId = this.$route.params.magazineId;
    }
    if (this.$isParamDefined('pagePosition')) {
      this.pagePosition = this.$route.params.pagePosition;
      if (this.pagePosition !== 0 && this.pagePosition !== null) {
        this.getFormNames();
      }
    }
    if (this.$isParamDefined('marketId')) {
      this.marketId = this.$route.params.marketId;
    }
    if (this.$isParamDefined('accordionIndex')) {
      this.productIndex = this.$route.params.accordionIndex || null;
    } else {
      this.productIndex = null;
    }
    this.$store.commit('setMagazineId', this.magazineId);
    this.$store.commit('setPagePosition', this.pagePosition);
    this.$store.commit('setMarketId', this.marketId);
    storage.set('projectId', this.projectId);
    storage.set('magazineId', this.magazineId);
    storage.set('pagePosition', this.pagePosition);
    storage.set('marketId', this.marketId);

    this.getPage();
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        let reload = false;
        if (this?.projectId != params?.projectId) {
          this.projectId = params.projectId;
        }
        if (this?.magazineId != params?.magazineId) {
          this.magazineId = params.magazineId;
          this.$store.commit('setMagazineId', this.magazineId);
          reload = true;
        }
        if (this?.pagePosition != params?.pagePosition) {
          this.pagePosition = params.pagePosition;
          this.$store.commit('setPagePosition', this.pagePosition);
          reload = true;
        }
        if (this?.marketId != params?.marketId) {
          this.marketId = params.marketId;
          this.$store.commit('setMarketId', this.marketId);
          reload = true;
        }
        if (params?.accordionIndex >= 0) {
          this.productIndex = params.accordionIndex || null;
        } else {
          this.productIndex = null;
        }
        if (reload) {
          this.getPage();
        }
      },
      deep: true
    }
  }
}
</script>
